import React from 'react';
import { Box } from '@mui/material';
import { colors } from '../theme/tokens';

const SkipLink = () => (
  <Box
    component="a"
    href="#main-content"
    sx={{
      position: 'fixed',
      top: 12,
      left: 12,
      zIndex: 3000,
      px: 2,
      py: 1,
      borderRadius: '8px',
      backgroundColor: colors.white,
      color: colors.black,
      fontWeight: 600,
      textDecoration: 'none',
      transform: 'translateY(-200%)',
      transition: 'transform .2s ease',
      '&:focus-visible': { transform: 'translateY(0)' },
    }}
  >
    Skip to content
  </Box>
);

export default SkipLink;
